// eslint-disable-next-line no-restricted-imports
import {view} from '@sail/ui';
import {SiteHeader} from '@sail/helm';
import {PageConfig} from 'mkt-ssr/lib/page/PageConfig';
import {createPage, InferPageProps} from 'mkt-ssr/lib/page';
import {createRouteGetServerSideProps} from 'mkt-ssr/lib/contentful/createRouteGetServerSideProps';
import {StartupPartnersPage} from '@stripe-internal/mkt-ssr-models';

/* eslint-disable no-restricted-imports */
import {HeroSection} from 'mkt-ssr/components/sail/pages/StartupPartners/HeroSection';
import {LeadingStartupSection} from 'mkt-ssr/components/sail/pages/StartupPartners/LeadingStartupSection';
import {WhyStripeSection} from 'mkt-ssr/components/sail/pages/StartupPartners/WhyStripeSection';
import {TestimonialSection} from 'mkt-ssr/components/sail/pages/StartupPartners/TestimonialSection';
import {FooterCTASection} from 'mkt-ssr/components/sail/pages/StartupPartners/FooterCTASection';
import {SiteFooterSection} from 'mkt-ssr/components/sail/SiteFooterSection/SiteFooterSection';
/* eslint-enable no-restricted-imports */

const config: PageConfig = {
  generateRoute: false,
  internal: false,
  globalized: false,
  indexed: false,
  uiEngine: 'sail',
};

export const getServerSideProps =
  createRouteGetServerSideProps(StartupPartnersPage);

export default createPage(
  function Index({page}: InferPageProps<typeof getServerSideProps>) {
    return (
      <view.div>
        <SiteHeader />
        <HeroSection
          partnerName={page.partnerName}
          partnerCode={page.partnerCode}
          benefitsTier={page.benefitsTier}
          waivedProcessingFee={page.waivedProcessingFee}
          currency={page.currency}
          customBenefits={page.customBenefits}
          waivedProcessingAmount={page.waivedProcessingAmount}
          creditAmount={page.creditAmount}
        />
        <LeadingStartupSection partnerName={page.partnerName} />
        <WhyStripeSection />
        <TestimonialSection testimonials={page.testimonials?.testimonials} />
        <FooterCTASection />
        <SiteFooterSection />
      </view.div>
    );
  },
  {
    metadata: ({page: {partnerName}}) => ({
      analytics: {
        id: `startup_benefits_page_${partnerName
          .toLowerCase()
          .replace(/\s+/g, '_')}`,
        title: `Startup Benefits for ${partnerName} | Stripe`,
      },
      social: {
        description: `The Stripe for Startups program now offers benefits to ${partnerName} startups to help you launch quickly and grow your revenue.`,
        image:
          'https://images.stripeassets.com/fzn2n1nzq965/5uAsm5rNAb6VcozGFAfhOz/f737ebfff544b42b56c54e20467d42db/startup-program-default-social-card.png',
      },
      seo: {
        indexed: false,
      },
    }),
    pageConfig: config,
  },
);
